export const communicationKeys = {
  all: ["communication"] as const,
  templates: () => [...communicationKeys.all, "templates"] as const,
  template: (id: string) => [...communicationKeys.all, "template", id] as const,
  sent: () => [...communicationKeys.all, "sent"] as const,
  sentByCase: (caseId: string) =>
    [...communicationKeys.all, "sent", "byCase", caseId] as const,
  received: () => [...communicationKeys.all, "received"] as const,
  receivedByCase: (caseId: string) =>
    [...communicationKeys.all, "received", "byCase", caseId] as const,
} as const;
